const kr = {
    aftersales:{
        "contactus":"연락주시면 빠른 응답 받으실 수 있습니다",
        "workorder":"작업 주문 내역",
        "createjob":"문의 글 작성하기",
        "submittinworkorder":"문의 글 작성 시 캡쳐 화면 및 계정 정보 등을 포함시켜 주시면 답변에 큰 도움이 됩니다.",
        "workordercontent":"워크오더 내용",
        "subscriptionaccount":"구독계정",
        "problemtype":"문의 내용",
        "tobeprocessed":"처리를 기다리다",
        "processed":"처리됨",
        "revoked":"취소",
        "create":"문의글 작성",
        "workorderno":"작업지시번호",
        "product":"제품",
        "status":"상태",
        "type":"유형",
        "ticket":"계정",
        "createtime":"생성 일자",
        "reply":"응대 내용",
        "operate":'시행',
        "onlinechat":"온라인 채팅",
        "resolveworkorder":"저희는 고객님이 작업 제출한 후에  최대한 빨리 해결드리겠습니다",
        "noworkorder":" 신청서  없음",
        "revoke":"Revoke",
        "content":"Content"
        
    },
    excode:{
        "redemptioncode":"쿠폰 등록",
        "pleaseredemptioncode":"쿠폰 코드를 입력하세요",
        "exchange":"등록",
        "notused":"사용하지 않음",
        "used":"이미 사용됨",
        "expired":"기한이 지났다",
        "status":"상태",
        "exchangetime":"쿠폰 등록 시간",
        "createtime":"생성 일자",
        "selectactivityarea":"활성 영역을 선택하십시오.",
        "optionaltraintickets":" 사용 가능 차표",
        "newpurchase":"신규 구매",
        "renew":"요금 갱신"
    },
    header:{
        "personaldetails":"개인 정보"
    },
    footer:{
        "contactus":"문의하기",
        "navigation":"사이트 맵",
        "home":"메인 화면",
        "friends":"제휴 회원",
        "subscribe":"구독",
        "aftersales":"고객센터",
        "help":"도움",
        "termsofuse":"이용약관",
        "refundpolicy":"환불정책",
        "privacypolicy":"개인정보처리방침",
        "paymentmethod":"결제 수단",
        "language":"언어",
        "map":"사이트 맵",
        "homescreen":"홈 화면",
        "setpreferences":"선호 설정",
        "setlanguage":"언어를 설정하십시오."
    },
    friends:{
        "promotioninfo":"할인정보",
        "currentlevel":"현재 등급",
        "content":"독점 프로모션 링크와 할인 코드를 다른 사람과 공유하여 수수료를 벌 수 있습니다.직급이 높을수록 커미션은 높아진다.",
        "rolemembers":"친구를 초대하실 수 있으며, 등급이 높을수록 더 높은 할인율 및 상품이 제공됩니다.",
        "promotionallinks":"프로모션 링크",
        "discountcodes":"할인코드",
        "copy":"복사",
        "rebateratio":"커미션비율",
        "discountratio":"할인비율",
        "lowestdiscountratio":"최저할인",
        "walletsandpoints":"잔고 및 포인트",
        "applywithdrawal":"당신이 인출 신청을 한 후, 우리는 7영업일 이내에 심사하여 지불할 것입니다",
        "withdraw":"현금 인출",
        "record":"현금인출기록",
        "integral":"적분",
        "pointsused":"포인트는 이벤트에 사용 가능합니다",
        "orderdetails":"주문 상세내역",
        "orderamount":"주문금액",
        "earnings":"수입",
        "withdrawalsrecord":"출금기록",
        "accounts":"장부",
        "accounttype":"계정 유형",
        "withdrawalamount":"인출액",
        "cancel":"취소",
        "submit":"제출하다",
        "greaterthan":"인출금액은 반드시 30보다 커야 한다！",
        "normal":"정상",
        "invalid":"무효",
        "bankcard":"은행카드",
        "promotionlink":"프로모션 링크",
        "discountcode":"할인코드",
        "waitingforapproval":"심사중",
        "waitingforpayment":"미지급",
        "notpass":"통과하지 못하다",
        "paid":"지불완료",

        "cashwithdrawalid":"인출번호 ID",
        "accountsreceivable":"외상매출금",
        "amount":"금액(USD)",
        "status":"상태",
        "applicationtime":"신청시간",
        "processingresults":"처리 결과",

        "sku":"상품",
        "orderid":"주문번호",
        "useramount":"주문 계정",
        "duration":"이용 기간",
        "promotiontype":"판촉유형",
        "createtime":"생성 일자",
        "eainings":"수익(달러)",

        "receivingaccount":"수취계정",
        "nowithdrawableamount":"인출할 금액이 없다",
        "copysuccessfully":"복사 성공",
        "copyfailed":"복사 실패",
        "salesvolume":"판매량",
        "nodata":"데이터 없음"
    },
    home:{
        'notice':'Netflix에 로그인할 수 없는 문제를 해결하려면 getNfcode를 클릭하세요.',
        'join':'저가 공유 구독',
        'Renewal':'Renew',
        "texttitle":" ",// 原内日：저가 공유 구독 更新
        "buynow":"즉시구매",
        "soldout":"품절",
        "delivery":"실시간 인증",
        "after":"결제 후 실시간 인증으로 대기 시간이 필요 없음.",
        "certificate":"SSL 인증",
        "payments":"SSL 보안 인증서를 사용하는 보안 환경 구축.",
        "onlinesupport":"24시간 온라인 고객 응대 서비스",
        "privatecustomer":"24시간 온라인 고객 응대 서비스",
        "subscriber":"구독 상품",
        "subscriptions":"프리미엄 서비스를 더 저렴한 가격으로 공유하실 수 있습니다. 동일한 국가/지역의 가입자에게 우선 매치를 해드립니다.",
        "moneyback":"환불 보장",
        "refund":"20일 내에 환불 신청이 가능합니다.(유튜브 프리미엄은 7일 이내,자세한 내용은 환불 정책을 읽어보세요.)",
        "parkingspace":"차량 위치",
        "gift":"선물",
        "screen":"하위 계정",
        "1screen":"1 하위계정",
        "maxnum":"하위 계정",
        "month":"월",
        "buytyp":"구매유형",
        "subscription":"subscription",
        "voucher":"쿠폰 등록",
        "discountcode":"할인코드",
        "use":"사용",
        "paymentmethod":"지불 방식",
        "pleasechoose":"선택해주세요",
        "billingdetails":"계산서상세",
        "payaddress":"계산서 상세주소",
        "firstname":"성",
        "lastname":"이름",
        "emailaddress":"메일주소",
        "phone":"phone number",
        "country":"국가/지역",
        "state":"성",
        "city":"마을 / 도시",
        "address":"거리 주소",
        "housenumber":"거리 번호",
        "suiteunit":"아파트, 스위트, 유닛 등(옵션)",
        "zipcode":"우편번호",
        "submit":"제출하다",
        "creditcard":"은행카드",
        "cardnumber":"카드 번호",
        "expirydate":"만기일",
        "nameoncard":"카드 소지자 이름",
        "savethiscard":"기본 카드로 저장",
        "play":"제출하다",
        "emailerror":"메일 오류",
        "payresluttitle":"지불에 성공하다",
        "Pleaseconfirmsuk":"상품 정보를 확인해 주십시오",
        "buytips": "우리는 공유 가족 계정입니다.한 번의 구매는 한 사람만 사용할 수 있습니다.\n"+
        "Youtube구매 완료 후 구독 페이지에서 이메일을 기입해주세요",
        "pleaseenter":"입력해 주세요",
        "selectamonth":"월을 선택하세요",
        "selectthenumber":"하위 계정 수를 선택하십시오",
        "selectthepurchase":"구매 유형을 선택하십시오",
        "selectthepayment":"지불 방식을 선택하세요",
        "discountcodenotempty":"우편번호는 비워둘 수 없습니다!",
        "detail1":
        // "<p>✅ 넷플릭스 정책 변화에 영향을 받지 않고 사용할 수 있습니다.</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>다섯 명이 하나의 계정을 공유하는 방식입니다.</span></p>\n" +
            // "<p>✅ 추후에 슬롯 구독을 판매할 예정입니다.</p>\n" +
            // "<p>✅ 추후에 슬롯 구독을 판매할 예정입니다.</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, 돌비</span></p>"+
            "<p><i class=\"el-icon-check\"></i><span>사용 중 문제가 발생할 경우 온라인 고객센터로 문의해주세요.</span></p>\n",
        "detail2":"<p><i class=\"el-icon-check\"></i><span>프리미엄 서비스</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>고음질 지원</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>실시간 인증</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>휴대폰, PC, 태블릿 지원</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3":"<p><i class=\"el-icon-check\"></i><span>프리미엄 서비스</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>하나의 계정을 6인이 공유</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>휴대폰, PC, TV 지원</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>독립 시청 기록.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>선호도와 목록 저장 가능</span></p>",
        "detail5":"<p><i class=\"el-icon-check\"></i><span>프리미엄 서비스</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>가족 초대 링크를 실시간으로 보내드립니다.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>구매 완료 후 구독 페이지에서 이메일을 기입해주세요.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>본인의 기존 계정을 그대로 사용하실 수 있습니다.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>시청 기록, 구독 목록도 그대로 유지됩니다</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>도움말: 구매하기 전에 play.google.com에서 계정 국가가 KR, ES, FR, PL, IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG, , CZ, SE, PT, BE, IL 인지 확인하세요.</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7":"<p><i class=\"el-icon-check\"></i><span>동일한 구독 갱신</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>선호도와 목록 저장</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>실시간 전송</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>환불보장</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>구매하기 전에 다음 링크를 열어 max를 사용할 수 있는지 확인하십시오.https://www.max.com/</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>공유 구독. 자세한 내용은 1화면 보기 전용(1/4)입니다</span></p>",
        "detail8":"<p><i class=\"el-icon-check\"></i><span>공식 4.0 모델</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>GPT 스토어 즐기기</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>실플러그인 사용 가능</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>API 금지</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>채팅 내용은 보호되어 있어 다른 사람이 볼 수 없습니다.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4.0 모델 채팅 조건은 제한되지 않습니다</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>24시간 이내 걱정 없이 환불 가능</span></p>",
        "detail9":"<p><i class=\"el-icon-check\"></i><span>4명이 구독 1개를 공유합니다.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>실시간 배송</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>모바일 단말기, PC, TV, TV 박스 지원</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, 돌비</span></p>",
        "detail10":
        // "<p>✅ 프리미엄 플랜, $2.99/월/스크린</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>1실시간으로 초대 링크 보내기</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>비공개 구독, 모두 유지</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>즐겨찾기 및 목록</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>환불보장</span></p>",
        "detail11":
            // "<p>✅ 프리미엄 플랜, $2.99/월/스크린</p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>개별 계정</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>한 명만 사용할 수 있는 계정</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>비공개 구독, 모두 보유</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>Netflix 정책의 영향을 받지 않습니다</span></p>\n"+
                "<p><i class=\"el-icon-check\"></i><span>코드 확인 코드가 나타나지 않습니다.</span></p>",
        "detail12":
                "<p><i class=\"el-icon-check\"></i><span>ChatGPT 계정 필요 없습니다.</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>보호받는 채팅 메시지.</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>GPT-4o 및 GPT-4o-mini 지원 가능.</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>GPT-4.1, GPT-4.5, GPT-o3 지원 가능.</span></p>\n"+
                "<p><i class=\"el-icon-check\"></i><span>고성능 서버로 안정적인 접속 보장드립니다.</span></p>",
        "detail13":
                "<p><i class=\"el-icon-check\"></i><span>교육용 플러스 플랜(Notion AI 제외)</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>모듈형 자유: 도구 전환 혼란 제거</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>통합 작업 공간: 도구 비용 57% 절감.</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>실시간 협업: 지연 없는 수요 조정.</span></p>",
        "detail14":
                "<p><i class=\"el-icon-check\"></i><span>슈퍼 듀오링고를 즐기세요</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>회원은 광고 없는 학습 환경을 누릴 수 있어, 각 수업 종료 시 광고 방해를 피하고 집중해서 공부할 수 있습니다</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>‘맞춤형 연습’ 기능을 사용하여 연습 중에 발생하는 오류를 교정하세요</span></p>\n" +
                "<p><i class=\"el-icon-check\"></i><span>회원은 고급 전설 레벨에 무제한으로 도전하여, 배운 내용을 심도 있게 숙달하고 언어 능력을 향상시킬 수 있습니다</span></p>",
        "lowerpricesharelarge":"에서 더 저렴한 가격으로 디지털 제품을 구독하기",
        "lowerpricesharesmall":"<span class='green-text-2'>AlongShare </span>에서 더 저렴한 가격으로\n디지털 제품을 구독하기",
        "highqualitystreaming":"3년 연속 고품질, 저렴한 가격 제공",
        "detail":"자세히 보기",
        "moreactivities":"이벤트많고 수확이 많다",
        "sharejoinsubscription":"<span class='green-text-2'>공유</span>구독",
        "shareyoursubscription":"친구와 공유하기 Alongshare",
        "availabletime":"친구분이 회원님의 전용 할인코드로 구매하면 ",
        "makemoney":"구매 금액의 일정 비율를 커미션으로 적립받으실 수 있으며,",
        "widerangesubscription":"상세한 프로모션 현황은 연합 프로그램에서 ",
        "threestepsshare":"실시간 조회 가능합니다.",
        "joinsubscription":"협력 가입",
        "saveupsubscriptionfees":"Naver/YouTube/Telegram에서 전용 할인코드를 강조해여",
        "securepayment":"홍보글이나 홍보영상을 발행하시면,",
        "manualreview":"연합 프로그램에서 프로모션 현황을 쉽게 확인할 수 있으며,",
        "oneclickjoin":"수익금 $30까지 적립시 현금 인출 가능합니다.",
        "whyusealongshare":"<span class='green-text-2'> Alongshare</span>을 사용하는 사람이 <span class='green-text-2'>많아지는</span> 이유",
        "position":"{0} 본",
        "selectdiscount":"할인 선택",
        "notstoreinfo":"AlongShare는 은행 카드 정보를 저장하지 않습니다.모든 거래는 외부 결제 제공업체에 의해 보호, 처리 및 승인됩니다.",
        "alumpsum":"일시불",
        "details":"상세 정보",
        "subtotal":"소계",
        "promotioncodescoupons":"프로모션 코드 & 쿠폰",
        "paymentfee":"결제 요금",
        "total":"합계",
        "nowastediscount":"이 할인을 놓치지 마세요!",
        "hoursjoin":"{hours} 시간 전에 가입",
        "minutesjoin":"{minutes}분 전에 가입했습니다"
    },
    login:{
        "welcomelogin":"로그인",
        "login":"로그인",
        "updatepwd":"암호 변경",
        "reg":"아이디 신청",
        "agreement":"약관에 동의합니다",
        "quicklogin":"빠른 로그인",
        "sendcode":"코드 전송",
        "register":"등기",
        "changepassword":"비밀번호 변경",
        "verificationcode":"인증 번호",
        "name":"이름",
        "password":"비밀번호",
        "agapassword":"비밀번호 다시 입력",
        "modify":"변경",
        //"validatepswlen":"비밀번호는 반드시 만족해야 합니다: 대문자, 소문자, 숫자, 특수문자 중 3개의 임의의 조합으로 길이가 8에서 16 사이입니다!",
        "validatepswlen":"암호는 문자, 숫자, 특수 문자를 모두 포함해야 합니다.",
        "checkagreement":"계약서를 확인하십시오",
        "passwordinconsistency":"두 번 입력한 암호가 일치하지 않습니다!",
        "passwordagain":"암호를 다시 입력하십시오",
        "verificationsend":"확인 코드가 전송되었습니다. 확인에 주의하십시오.",
        "useemail":"이메일 주소 사용 ",
        "agree":"계속 진행 시",
        "and":"및",
        "andconfirm":"에 동의하며 ",
        "readour":"내용 확인한 것으로 간주합니다.",
        "forgotpassword":"비밀번호를 잊었습니다.",
        "codelogin":"인증 코드를 사용하여 로그인",
        "verifyemail":"메일  확인",
        "sendcodeemail":"인증 코드를 {email} 에 이메일로 보냈으니 코드 입력하시면  등록완성합니다다",
        "continue":"계속",
        "resend":"다시 보내",
        "noreceivecode":"인증 코드 못 받다 ? ",
        "passwordlogin":"비밀번호로 로그인",
        "setpassword":"비밀번호 설치",
        "confirmpassword":"비밀번호  확인"
    },
    luckdraw:{
        "lotteryticket":"복권",
        "integral":"적립된 포인트",
        "welcome":"이벤트 페이지입니다.\n" +
            " 카드를 선택하면 무료 계정 패키지 또는 할인 코드 등의 경품을 받으실 수 있습니다.",
        "none":"없음",
        "redemptioncode":"쿠폰 등록",
        "copy":"복사",
        "prizelist":"상품 목록",
        "notused":"사용하지 않음",
        "used":"사용했어요",
        "expired":"기한이 지났다",

        "prizeno":"상품 번호",
        "contents":"상품 내용",
        "exchangedate":"환산일/사용일",
        "createtime":"생성 일자",
        "exchange":"등록",
        "insufficientpoints":"포인트 부족!",
        "consumepoints":"이 작업은 10포인트가 소모됩니다.계속하시겠습니까?",
        "tips":"팁들",
        "comfirm":"확인",
        "cancel":"취소",
        "failtowin":"당첨되지 못하다",
        "congratulations":"획득을 획득했습니다",
        "copysucceeded":"복사 성공!",
        "copyfailed":"복사 실패!",
    },
    subscribe:{
        "clickto":"링크를 받으려면 클릭하세요.",
        "Resend":"이미 새 코드를 다시 보냈나요? 다시 받으세요",
        "getverificationlink":"로그인 확인 링크 받기",
        "getlinktips":"인증 코드를 입력하라는 메시지가 표시되지 않은 경우 이 기능을 무시하십시오.",
        "renewnow":"즉시갱신",
        "subscription":"동일한 구독료를 갱신",
        "independent":"4K+HDR 고화질, 독립 시청 기록",
        "guarantee":"환불보장",
        "timeleft":"남은 시간",
        "openingtime":"계정 시작 시간",
        "endtime":"종료 시간",
        "account":"계정 아이디",
        "password":"비밀번호",
        "profile":"파일",
        "pleaseuse":"번 계정을 이용해 주세요",
        "subaccount":"서브계정",
        "myprofile":"제 프로필이 누군가에 의해 남용되었습니다!",
        "renew":"갱신",
        "aftersales":"애프터서비스",
        "paidquota":"결제 할당량",
        "nextresetdate":"다음 재설정 날짜",
        "submitYoutube":"이메일 주소를 제출한 후,홈그룹에 가입하려면 ”가입“ 버튼을 클릭하기만 하면 됩니다.또는 홈그룹에 가입하려는 계정의 구글 크롬 계정에 대한 링크를 복사하여 여세요.",
        "yourownsub":"1.번호에 따라 자신의 아이디를 사용하세요.",
        "delete":"2.다른 하위 계정은 수정/삭제하지 마십시오",
        "modifysubscription":"3. 구독 관련 정보는 수정하지 마십시오",
        "reminder":"팁: 문제가 발생하면 즉시 고객 서비스에 연락하여 alongshare에서 구독을 구매하고 VIP 고객 서비스를 즐기십시오. 갱신 시 번호 변경이 필요하지 않습니다..",
       
       
        "subtime":"구독 기간이 일시 중지되었으며 만료되지 않습니다. 문제가 해결된 후에만 요금이 청구됩니다.",
        "subtimetips":"문제가 해결되면 타이머가 다시 시작됩니다.",
        // "youtubeloginemail":"YouTube 로그인 이메일을 입력합니다. 로그인 이메일 주소를 사용하여 가족 그룹에 가입해야 합니다. 그렇지 않으면 가족에서 쫓겨날 것입니다. 도움이 필요하시면 Alongshare 고객 서비스에 이메일로 연락하십시오.",
        "youtubeloginemail":"YouTube 로그인 이메일을 입력하세요. 가족 그룹에 가입하려면 입력한 이메일 주소를 사용해야 합니다.그렇지 않을 경우 가족 그룹에서 탈퇴 됩니다. 도움이 필요하시면 홈페이지 우측 하단의",
        "aftersalesservice":"애프터서비스",
        "support":"지원 페이지.",
        "submit":"제출하기",
    
        "buyit":"아직 구독이 없습니다. 서둘러 구입하십시오",
        "paymentsucceeded":"결제 성공",
        "month":"월을 선택하세요.",
        "number":"하위계정수량을선택하십시오",
        "purchase":"구매 유형을 선택하십시오",
        "payment":"지급 방법을 선택하십시오",
        "name":"카드에 이름을 입력하십시오",
        "card":"카드 번호를 입력하십시오",
        "cvv":"CVV를 입력하십시오.",
        "expirydate":"만료 날짜를 입력하십시오.",
        "processing":"처리현황이제출되었습니다. 워크오더의 처리상태를 확인합니다.",
        "cannotempty":"할인 코드는 비워 둘 수 없습니다!",
        "originalpassword":"이 작업에 대한 원래 암호는 더 이상 사용되지 않습니다. 계속하시겠습니까?",
        "passwordmeets":"비밀번호 설정 요건: 대소문자, 숫자, 특수문자 중 3개를 임의로 조합하여 길이가 8에서 16 사이입니다!",
                //套餐名字
        //nf
        "11screen":"1 profile (5 people Shared)(1/5 TV)",
        "21screen":"1 profile (4 people Shared)(1/4 TV)",
        "31screen":"1 profile (5 people Shared)(1/1 TV)",
        "41screen":"1 profile (5 people Shared)(No TV)",
        "51screen":"5 profiles (Private)",
        "61screen":"solo subscription",
        "71screen":"Recharge (with your own account)",
        //sp
        "12screen":"1 profile (5 people Shared)",
        "72screen":"Recharge (with your own account)",
        //dsn
        "13screen":"1 profile (7 people Shared)",
        "53screen":"Private",
        //ytb
        "15screen":"1 profile (5 people Shared)",
        "75screen":"Recharge (with your own account)",
        //max
        "17screen":"1 profile (4 people Shared)",
        //gpt
        "18screen":"token+6 people Shared account",
        "58screen":"Private",
        "78screen":"Recharge (with your own account)",
        //脆卷
        "19screen":"1 profile (4 people Shared)",
        //plmount
        "110screen":"1 profile (4 people Shared)",
        //notion
        "113screen":"1 profile",
        //duolingo
        "114screen":"1 profile (5 people Shared)",
        //team
        "115screen":"1 profile",
    
    },
    userinfo:{
        "signout":"로그아웃",
        "nickname":"닉네임",
        "avatar":"아바타",
        "uploadavatar":"아바타를 업로드하십시오",
        "logout":"로그아웃하시겠습니까?",
        "onlyjpgpng":"업로드된 사진은 JPG | png 형식만 가능합니다.",
        "cannotexceed":"업로드된 이미지의 크기는 5MB를 초과할 수 없습니다!",
        "exitalongshare":"AlongShare를 종료하시겠습니까?",
        "personaldata":"개인정호",
        "clickimage":"사진을 클릭하여 편집하기",
        "edit":"편집",
        "alongshareloginemail":"AlongShare 로그인 이메일",
        "save":"저장",
        "resetpassword":"비밀번호 재설정",
        "editpassword":"비밀번호 편집",
        "passwordmust":"비밀번호는 다음 조건이 있어야 합니다.",
        "anycharacter":"임의 자모 , 숫자, 특수 문자",
        "twosamepasswords":"입력하신 두  비번는 동일합니다.",
        "currentpassword":"현재 비번",
        "newpassword":"새 비번",
        "confirmpassword":"비번 확인",
        "updatepassword":"비번 업데이트"
    },
    wish:{
        "wish":"소원",
        "help":"AlongShare는 소원을 골라서 이루어줍니다.",
        "christmas":"소원을 남겨주세요. 크리스마스가 오면 그들은 그것을 이룰 것입니다.",
        "submit":"제출",
        "mywish":"내 소원"
    },
    map:{
        "home":"메인 화면",
        "userinfo":"회원 정보",
        "login":"로그인",
        "withfriends":"추천 코드",
        "subscribe":"구독 상품",
        "aftersales":"고객센터",
        "Luckdraw":"이벤트",
        "wish":"소원",
        "helpcenter":"고객센터",
        "tradingstamps":"쿠폰 사용",
        "affiliateprogram":"연합 프로그램",
        "order":"주문"
    },
    order:{
        "whetherpayment":"결제여부",
        "yes":"여",
        "no":"부"
    }
}

export default kr
